// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".role-box .edit-head span {\n  display: inline-block;\n  height: 20px;\n  line-height: 20px;\n  padding-right: 40px;\n}", ""]);
// Exports
module.exports = exports;
